<form [formGroup]="form">
  <app-input-group>
    <label appLabel>{{ 'meterFrame.type' | translate }}</label>
    <select appInput formControlName="meterFrameType">
      <option disabled selected value="null">{{ 'meterFrame.form.chooseType' | translate }}</option>
      <option value="Primary">{{ 'meterFrame.types.primary' | translate }}</option>
      <option value="Station">{{ 'meterFrame.types.station' | translate }}</option>
      <option value="Serial">{{ 'meterFrame.types.serial' | translate }}</option>
      <option value="Parallel">{{ 'meterFrame.types.parallel' | translate }}</option>
    </select>
  </app-input-group>

  @if (form.get('meterFrameType')?.value === "Serial" || form.get('meterFrameType')?.value === "Parallel") {
    <app-input-group>
      <label appLabel>{{ 'meterFrame.unittype' | translate }}</label>
      <select appSelect [collection]="unitTypeList" formControlName="unitType">
      </select>
    </app-input-group>
  }

  @if (form.get('meterFrameType')?.value) {
    <app-input-group>
      <label appLabel>{{ 'meterFrame.priority' | translate }}</label>
      <input appInputNumber formControlName="priority"
             placeholder="{{ 'meterFrame.form.enterPriority' | translate }}"
             min="0"
      >
    </app-input-group>

    <app-input-group>
      <label appLabel>{{ 'meterFrame.identification' | translate }}</label>
      <input appInput formControlName="identification"
             placeholder="{{ 'meterFrame.form.enterIdentification' | translate }}">
    </app-input-group>
  }

  @if (form.get('meterFrameType')?.value === "Station") {
    <app-input-group>
      <label appLabel>{{ 'meterFrame.transformer' | translate }}</label>
      <input appInput formControlName="transformer"
             placeholder="{{ 'meterFrame.form.enterTransformer' | translate }}">
    </app-input-group>
  }

  @if (form.get('meterFrameType')?.value === "Serial" || form.get('meterFrameType')?.value === "Parallel") {
    <app-input-group>
      <label appLabel>{{ 'meterFrame.primaryMeterFrame' | translate }}</label>
      <select appSelect [collection]="meterFramesList" formControlName="primaryMeterFrameId"></select>
    </app-input-group>

    <app-input-group>
      <label appLabel>{{ 'meterFrame.capacity' | translate }}</label>
      <input appInput type="number" formControlName="capacity"
             placeholder="{{ 'meterFrame.form.enterCapacity' | translate }}"
             append="kW"
             min="0"
      >
    </app-input-group>
  }

  @if (form.get('meterFrameType')?.value) {
    <div class="py-2 text-sm font-semibold">
      {{ 'meterFrame.description' | translate }}
    </div>

    <app-input-group>
      <label appLabel>{{ 'meterFrame.form.enterDescription' | translate }}</label>
      <textarea appInput formControlName="description"
                placeholder="{{ 'meterFrame.form.enterDescription' | translate }}" rows="4"></textarea>
    </app-input-group>
  }

  @if (form.get('meterFrameType')?.value === "Primary" || form.get('meterFrameType')?.value === "Station") {
    <app-input-group>
      <label appLabel>{{ 'meterFrame.maximumPower' | translate }}</label>
      <input appInput type="number" formControlName="maximumPower"
             placeholder="{{ 'meterFrame.form.enterMaximumPower' | translate }}" append="kW"
             min="0"
      >
    </app-input-group>

    <app-input-group>
      <label appLabel>{{ 'meterFrame.limitedGridAccess' | translate }}</label>
      <input appInput type="number" formControlName="limitedGridAccess"
             placeholder="{{ 'meterFrame.form.enterLimitedGridAccess' | translate }}" append="A"
             min="0"
      >
    </app-input-group>

    <app-input-group>
      <label appLabel>{{ 'meterFrame.maximumCurrent' | translate }}</label>
      <input appInput type="number" formControlName="maximumCurrent"
             placeholder="{{ 'meterFrame.form.enterMaximumCurrent' | translate }}" append="A"
             min="0"
      >
    </app-input-group>

    <app-input-group>
      <label appLabel>{{ 'meterFrame.networkPlacement' | translate }}</label>
      <select appSelect [collection]="gridConnectionLevelList" formControlName="networkPlacement">
      </select>
    </app-input-group>

    <!-- Omregninsfaktor -->
    <div class="py-2 text-sm font-semibold">
      {{ 'meterFrame.conversionFactor' | translate }}
    </div>

    <app-input-group>
      <label appLabel>A14</label>
      <input appInput formControlName="conversionFactorA14" min="0.0001" required step="any" type="number" [readonly]="true">
    </app-input-group>

    <app-input-group>
      <label appLabel>A23</label>
      <input appInput formControlName="conversionFactorA23" min="0.0001" required step="any" type="number" [readonly]="true">
    </app-input-group>

    <app-input-group>
      <label appLabel>R12</label>
      <input appInput formControlName="conversionFactorR12" min="0.0001" required step="any" type="number" [readonly]="true">
    </app-input-group>

    <app-input-group>
      <label appLabel>R34</label>
      <input appInput formControlName="conversionFactorR34" min="0.0001" required step="any" type="number" [readonly]="true">
    </app-input-group>
  }

  @if (form.get('meterFrameType')?.value === "Serial" || form.get('meterFrameType')?.value === "Parallel") {
    <!-- Omregninsfaktor -->
    <div class="py-2 text-sm font-semibold">
      {{ 'meterFrame.conversionFactor' | translate }}
    </div>

    <app-input-group>
      <label appLabel>A14</label>
      <input appInput formControlName="conversionFactorA14" min="0.0001" required step="any" type="number" [readonly]="true">
    </app-input-group>

    <app-input-group>
      <label appLabel>A23</label>
      <input appInput formControlName="conversionFactorA23" min="0.0001" required step="any" type="number" [readonly]="true">
    </app-input-group>

    <app-input-group>
      <label appLabel>R12</label>
      <input appInput formControlName="conversionFactorR12" min="0.0001" required step="any" type="number" [readonly]="true">
    </app-input-group>

    <app-input-group>
      <label appLabel>R34</label>
      <input appInput formControlName="conversionFactorR34" min="0.0001" required step="any" type="number" [readonly]="true">
    </app-input-group>
  }
</form>
